import { FIELD_TYPES } from "../../widgets/fields";

export const SurveyFormElements = {
    language: {
        name: "language",
        placeholder: "Select",
        label: "Language",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
    },
    localized_value: {
        name: "localized_value",
        placeholder: "Enter",
        label: "Variable Name",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    number_of_speakers: {
        name: "number_of_speakers",
        placeholder: "Enter",
        label: "Number of Speakers",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "1", value: 1 },
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
            { label: "6", value: 6 },
            { label: "7", value: 7 },
            { label: "8", value: 8 },
            { label: "9", value: 9 },
            { label: "10", value: 10 },
            { label: "11", value: 11 },
            { label: "12", value: 12 },
            { label: "13", value: 13 },
            { label: "14", value: 14 },
            { label: "15", value: 15 },
        ],
        isMandatory: true,
    },
    is_translate: {
        name: "is_translate",
        placeholder: "Select",
        label: "Translate Conversation",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        isMandatory: false,
    },
    prompt_message: {
        name: "prompt_message",
        placeholder: "Please Enter the context of data collection. E.g., 'Interaction between doctor and patient', 'discussion between doctors.'",
        label: "Prompt Message (Optional)",
        type: FIELD_TYPES.TEXT_AREA,
        isMandatory: false,
    }
}